import React from 'react';
import { Link } from 'react-router-dom';
import { MarketingSiteNav } from '../../components/marketing/MarketingSiteNav';
import { ROUTES } from '../../utils/constants';

const TermsPage: React.FC = () => (
  <div className="min-h-screen bg-app-bg dark:bg-gray-950 text-app-text dark:text-gray-100">
    <MarketingSiteNav onSubpage />

    <main className="mx-auto max-w-3xl px-4 py-12 sm:py-16 prose prose-slate dark:prose-invert max-w-none">
      <h1 className="text-3xl font-extrabold">Terms of Service</h1>
      <p className="text-sm text-app-text-muted dark:text-gray-400">Last updated: May 2026</p>

      <section className="mt-8 space-y-4 text-app-text-muted dark:text-gray-300">
        <h2 className="text-xl font-bold text-app-text dark:text-white">1. Acceptance</h2>
        <p>
          By accessing Tamil Katral Maiyam (&quot;TKM&quot;), you agree to these Terms of Service. If you
          use TKM on behalf of a school or organization, you represent that you have authority to bind
          that organization.
        </p>

        <h2 className="text-xl font-bold text-app-text dark:text-white">2. Service description</h2>
        <p>
          TKM provides an AI-powered Tamil learning platform for schools, including tools for teachers,
          students, and administrators. Features may include AI tutors, Picture Talk, analytics, and
          content modules subject to your subscription plan.
        </p>

        <h2 className="text-xl font-bold text-app-text dark:text-white">3. School accounts</h2>
        <p>
          School administrators are responsible for inviting users, managing seats, and ensuring
          appropriate use by students and staff. You must keep login credentials secure and comply with
          applicable child privacy laws.
        </p>

        <h2 className="text-xl font-bold text-app-text dark:text-white">4. Subscriptions and billing</h2>
        <p>
          Paid plans are billed according to the plan selected at checkout. Payments are processed by
          Stripe. Renewal, cancellation, and invoices are managed through your school billing portal.
          See our{' '}
          <Link to={ROUTES.PRICING} className="text-primary-600 underline">
            pricing page
          </Link>{' '}
          for plan details.
        </p>

        <h2 className="text-xl font-bold text-app-text dark:text-white">5. Acceptable use</h2>
        <p>
          You may not misuse the platform, attempt to bypass usage limits, or use AI features in ways
          that violate school policies or applicable law. TKM may suspend access for abuse or
          non-payment.
        </p>

        <h2 className="text-xl font-bold text-app-text dark:text-white">6. Privacy</h2>
        <p>
          Our handling of personal data is described in the{' '}
          <Link to={ROUTES.PRIVACY} className="text-primary-600 underline">
            Privacy Policy
          </Link>
          .
        </p>

        <h2 className="text-xl font-bold text-app-text dark:text-white">7. Contact</h2>
        <p>
          Questions about these terms:{' '}
          <Link to={ROUTES.CONTACT} className="text-primary-600 underline">
            Contact sales
          </Link>{' '}
          or email{' '}
          <a href="mailto:sales@tamilkatralmaiyam.org" className="text-primary-600 underline">
            sales@tamilkatralmaiyam.org
          </a>
          .
        </p>

        <p className="text-sm italic">
          This is a placeholder terms document for launch. Legal review is recommended before production
          use.
        </p>
      </section>
    </main>
  </div>
);

export default TermsPage;
